<template>
    <button @click="doClick"
        :disabled="isLoading"
        class="btn btn-block schedule-print-button" 
        title="Download schedule as PDF"
    >
        <CloudArrowDownFill class="icon-default" />
        <span><slot>PDF</slot></span>
    </button>
</template>
<script>
import EventService from '@/services/EventService';
import CloudArrowDownFill from '@/components/icons/CloudArrowDownFill';

export default {
    name: 'SchedulePrintButton',
    components: {
        CloudArrowDownFill,
    },
    data: function() {
        return {
            isLoading: false,
        };
    },
    methods: {
        async doClick() {
            this.isLoading = true;
            const location = await EventService.getSchedulePrintRedirect();
            console.log("LOCATION:", location);
            if (location) {
                // TODO: trigger redirect in new window
                console.log("SUCCESS");
                this.isLoading = false;
                window.open(location, '_blank');
            }
            // const printURL = new Promise(EventService.getSchedulePrintRedirect);

            // printURL.then(response => {
            //         this.isLoading = false;
            //         console.log("SchedulePrintButton URL:", response);
            //         return response;
            //     })
            //     .catch(response => {
            //         console.log("SchedulePrintButton Error:", response);
            //     });
            
        },
    }
}
</script>
<style>
button.schedule-print-button {
    padding-left: 12px;
    padding-right: 12px;

    align-items: center;
    display: flex;
    gap: 10px;
}
/* .schedule-print-button-icon {
    min-height: 16px;
    min-width: 16px;
    height: 16px;
    width: 16px;
} */
</style>